const sidenav = document.querySelector('.page-sidenav__list');
const content = document.querySelector('.page-content');
const headers = content.querySelectorAll('h2');

headers.forEach((h) => {
  h.id = h.textContent
    .trim()
    .toLowerCase()
    .replaceAll(' ', '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const item = document.createElement('li');
  const link = document.createElement('a');
  link.className = 'page-sidenav__link';
  link.href = `#${h.id}`;
  link.textContent = h.textContent.toLowerCase();
  link.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById(h.id).scrollIntoView({ behavior: 'smooth' });
  });

  item.appendChild(link);
  sidenav.appendChild(item);
});
